import React, { Component } from "react"
// import modalIcon from "../../../assets/images/testIcon.svg"
// import Audit from "../../Common/audit"
// import Field from "../../../Common/Field/Field"
import Async from "react-select"
import { PermissionServices } from "../../../services"
import moment from "moment"
// import "./index.css"
// import MeasurementModal from "../PatternModule/MeasurementModal/MeasurementModal"
// import Button from "../../../Buttons/Button"
import "./sampleMobileApp.css"
import { withRouter } from "react-router-dom"
import MobileAppFields from "./MobileAppFields"
import Calendar from "../../../assets/images/MobileApp/calendar.svg"

  class ModuleHeader extends Component {
  state = {
    assignedToList: []
    // statusOption: [
    //   { label: "CANCEL", value: "CANCEL" },
    //   { label: "COMPLETED", value: "COMPLETED" },
    //   { label: "IN PROCESS", value: "INPROCESS" },
    //   { label: "PENDING", value: "PENDING" }
    // ]
  }

  componentWillMount() {
    this.searchEmpList("")
    const { process, disabled } = this.props
    this.setState({
      process,
      disabled
    })
  }

  componentWillReceiveProps(nextProps) {
    // this.searchEmpList("")
    const { process, disabled } = nextProps
    this.setState({
      process,
      disabled
    })
  }

  // componentDidMount() {
  //   this.searchEmpList("")
  // }

  searchEmpList = value => {
    PermissionServices.searchEmploye(value).then(async res => {
      if (res.status == 200) {
        this.setState({ assignedToList: await res.text.data })
      }
    })
  }

  render() {
    const { state } = this.props.location;
    const { assignedTo, status, ETA, processDate } = this.state.process
    const { placeOfSewing, statusList, measurementModal } = this.props
    //console.log(this.props,"moduleheaderrporps")

    return (
      




      <React.Fragment>

        <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
          
                    <div className="select-qr" style={{width:"100%"}} >
                                            <span className="label1">Assigned To</span>
                                            <div class="mobileAppAsync" style={{width:"100%"}}>
              <Async
                name="assignedTo"
                value={assignedTo}
                onChange={value =>
                  this.props.updateModulesMain(
                    "assignedTo",
                    value,
                    this.props.moduleName
                  )
                }
                placeholder="Find AssignedTo"
                options={this.state.assignedToList}
                disabled={this.state.disabled}
              />
            </div>
        
                                        </div>
                                        <MobileAppFields
            isFormGroup={true}
            inputType="select"
            inputName="status"
            value={status}
            label="Status"
            options={statusList}
            onChange={(name, value) =>
              this.props.updateModulesMain(name, value, this.props.moduleName)
            }
            disabled={this.state.disabled}
          />
                                        </div>
        
                                        <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
                    
                                            {/* <span className="label1">ETA Date</span>
                                            <select class="dropdown1" >
                                            <option value="option1">Option 1</option>
                                            <option value="option2">Option 2</option>
                                            </select> */}
                                            <MobileAppFields
                                            durationETA={this.props.durationETA}
                                            isFormGroup={true}
                                            inputType="date"
                                            inputName="ETA"
                                            value={ETA}
                                            label={"ETA Date"}
                                            onChange={(name, value) =>
                                            this.props.updateModulesMain(name, value, this.props.moduleName)
                                            }
                                            disabled={this.state.disabled}
                                        />
        
                                        
                                        <div className="select-qr" style={{width:"100%"}}>
                                            <span className="label1">Completed Date</span>
                                            {status == "COMPLETED" ? (
                                                <span className="completed-date-mdheader">
                                                    {processDate !== null
                                                    ? moment(processDate).format("DD MMM YYYY")
                                                    : ""}
                                                    <img src={Calendar} alt="calender" />
                                                </span>
                                                ) : (
                                                  // <span style={{display:"flex",justifyContent:"flex-start",alignItems:"center",width:"100%",
                                                  //   height:"100%"
                                                  // }}>-</span>
                                                  <span className="completed-date-mdheader">
                                                  -
                                                  <img src={Calendar} alt="calender" />
                                                  </span>
                                                    
                                                )}
                                                
        
                                        </div>
                                        {/* <MobileAppFields
                                        isFormGroup={true}
                                          label={"Completed Date"}
                                          options={[{label:1,id:22,label:2,id:33}]}
                                          inputType="select"
                                          inputName="Completed Date"
                                          /> */}
                                        </div>
                                            
                                        {placeOfSewing !== undefined && (
          <div className="select-qr" style={{flex:"1"}}>
            <MobileAppFields
              isFormGroup={true}
              inputType="select"
              inputName="placeOfSewing"
              value={
                placeOfSewing !== null || (this.props.PLACEOFSEWING && this.props.PLACEOFSEWING[0].value)
              }
              label={"Place of sewing"}
              options={this.props.PLACEOFSEWING || []}
              onChange={this.props.updateSewing}
              disabled={this.state.disabled}
            />
          </div>
        )}
        </React.Fragment>
    )
  }
}
export default withRouter(ModuleHeader);


// WEBPACK FOOTER //
// ./src/pages/Sample/SampleMobileApp/MbModuleHeader.js